export default __webpack_public_path__ + "EligibleProduct2.01dc8bbc.png";